export class IPatientForms { 
    
    patientFormId : number;     
    patientId : number;        
    practiceForm : number;   
    effectiveDate : Date;
    exprirationDate : Date;        
    description : string;        
    signoffDateTime : Date;
    patientSignature : any;
    isActive : boolean;        
    createdBy : string;        
    createdOn :Date;      
    modifiedBy : string;        
    modifiedOn : Date; 
    practiceFormTitle: string;
    patientName: string;
    activeStatus: string;
    effective:string;
    expiration:string;
    gender:string;
    driverName:string;
    visitDate:Date;
    
}


export class IDocLibPatientForms { 
    
     EMRDocLibID:number;
     FormName:string;
     FormData :string;
     FormHTMlConsentData:String;
     FormID :number;

     TargetLocID :number;
     DocDestID :number;
     ExpirationDays :number;

     ValidFrom :Date;
     ValidUpto:Date;
     VisitDate:Date;

     IsActive:boolean;
     PatientID:number;
     PatientAppointmentID:string;
     EncounterID:string;
     FacilityID:number;
     LocationID: number;

     SignatureID:number;
     SignatureBY:String;
     SignatureDate:Date;
     Signature:any ;
     SignatureRole:string;
   //  SignatureUserID:String;
     CreatedUserBy:String;
     IsReadyToSignoff?:boolean;     
	SignatureList :string;
     OtherInfo?:string;
     ProviderId? : string;
     IsProviderSignOff? : boolean;
     ScreenType? : string;
     ReadytoSignOffOn? :string;
}
 /*export class IDocLibPatientForms_Signatures
{
    EMRDocLibID:number;
     SignatureID:number; //id for nurse/patient/others
     SignatureBY:number; //name of the signature
     SignatureDate:Date; //Date
     Signature:any //Signature var binary
}*/

export class IDocLibPatientForms_Signatures
{
     EMRDocLibID:number;
     SignatureRole:string;
     SignatureID:string; //id for nurse/patient/others
     SignatureBy:string; //name of the signature
     Signature:any //Signature var binary
     signatureOn:Date; //Date
     OtherInfo?:string;
}

